import 'rxjs/add/operator/map';
import 'rxjs/add/operator/switchMap';
import 'rxjs/add/operator/catch';
import { type ActionsObservable } from 'redux-observable';
import { of } from 'rxjs/observable/of';

import { fetchFailed, fetchSuccess } from '../../common/fetch-request-analytics';

import {
	FETCH_PERSONALIZATION_SITE_TRAITS,
	updatePersonalizationSiteTraits,
	fetchPersonalizationSiteTraitsFailed,
} from '../actions/personalization-site-traits';

import { requestPersonalizationSiteTraits$ } from './requests';
import { getCloudId } from '../context/selectors';

export default (action$: ActionsObservable<any>, store: any) =>
	action$.ofType(FETCH_PERSONALIZATION_SITE_TRAITS).switchMap(() => {
		const cloudId = getCloudId(store.getState());
		return requestPersonalizationSiteTraits$(cloudId)
			.map((traits) => {
				fetchSuccess('personalization.site.traits');
				return updatePersonalizationSiteTraits(traits);
			})
			.catch((err) => {
				fetchFailed('personalization.site.traits', err);
				return of(fetchPersonalizationSiteTraitsFailed());
			});
	});
